const serverUrl =
  (window as any).QUIZZ_SERVER_URL ||
  process.env.REACT_APP_QUIZZ_SERVER_URL ||
  "https://back.qa.quizzdegenie.com";
const strapiUrl =
  (window as any).STRAPI_SERVER_URL ||
  process.env.REACT_APP_STRAPI_API_URL ||
  "https://api.qa.quizzdegenie.com";
const apiPath =
  (window as any).API_PATH || process.env.REACT_APP_API_PATH || "";

export const QUIZZ_SERVER_URL = serverUrl + apiPath;
export const QUIZZ_SOCKET_URL = serverUrl;
export const STRAPI_SERVER_URL = strapiUrl + apiPath + "/api";
export const API_PATH = apiPath;

console.log("##### STRAPI_SERVER_URL :", STRAPI_SERVER_URL);
console.log("##### QUIZZ_SERVER_URL :", QUIZZ_SERVER_URL);
